import { render, staticRenderFns } from "./Coluna.vue?vue&type=template&id=20094d71&scoped=true"
import script from "./Coluna.vue?vue&type=script&lang=js"
export * from "./Coluna.vue?vue&type=script&lang=js"
import style0 from "./Coluna.vue?vue&type=style&index=0&id=20094d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20094d71",
  null
  
)

export default component.exports